import { useQuery } from '@tanstack/react-query';

import LereService from '~/services/LereService';

import { heatmapSurchargeQueryKeys } from './heatmapSurchargeQueryKeys';

const pollIntervalMs = 2_000;

export function useGetHeatmapSurchargeJob(jobId: string) {
  return useQuery({
    queryKey: [...heatmapSurchargeQueryKeys.all, 'job', jobId],
    queryFn: ({ signal }) => LereService.getSurchargeJobStatus(jobId, { signal }),
    refetchInterval: (query) =>
      query.state.error || query.state.data?.status === 'success' || query.state.data?.status === 'failure'
        ? false
        : pollIntervalMs,
    retry: false,
    staleTime: 0,
  });
}
